import * as React from 'react';
import './App.css';
import { Paper, ThemeProvider } from '@mui/material';
import { createTheme } from '@mui/material/styles'
import { Outlet } from 'react-router';
import ProtectedRoute from './components/ProtectedRoute';

const theme = createTheme({
    colorSchemes: {
        dark: {
            palette: {
                primary: {
                    main: '#17a2c6',
                    contrastText: 'white'
                },
            }
        },
    },
    palette: {
        primary: {
            main: '#17a2c6',
        }
    }
});


function App(): JSX.Element {
    return (
        <ProtectedRoute>
            <ThemeProvider theme={theme}>
                <Paper sx={{
                    maxWidth: '640px',
                    height: '100%',
                    margin: 'auto',
                    position: 'relative'
                }}>
                    <Outlet />
                </Paper>
            </ThemeProvider>
        </ProtectedRoute>
    );
}

export default App;